import React from 'react'
import PropTypes from 'prop-types'
import { StandardPage } from 'components/DefaultPages'
import { useLogEvent } from 'components/hooks'

const SuccessPage = ({ history }) => {
  const goBack = () => {
    (history.length > 3) ? history.go(1 - history.length) : history.goBack()
  }

  useLogEvent('updated_profile')

  return (
    <StandardPage
      headerI18nKey={ 'pages.profile.success.title' }
      infoI18nKey={ 'pages.profile.success.info' }
      type={ 'success' }
      goBack={goBack}
    />
  )
}

SuccessPage.propTypes = {
  history: PropTypes.object.isRequired,
}

export default SuccessPage
